import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ADMIN } from "./_shared.js";

/**
 * `GRP-EDIT-INFO` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/settings` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 8 — sửa tên/ảnh nhóm, tạm redirect).
 */
export const GRP_EDIT_INFO = {
  id: "GRP-EDIT-INFO",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ADMIN,
  flags: [],
  slots: [],
  llm: {
    description:
      "Sửa TÊN GỌI của nhóm, ảnh đại diện và phần mô tả giới thiệu. Chỉ đổi chữ và ảnh; KHÔNG đổi người — trao quyền chủ nhóm hay 'sang tên nhóm cho người khác' là GRP-OWNERSHIP.",
    examples: [
      "đổi tên nhóm",
      "doi ten nhom",
      "sửa ảnh nhóm",
      "sua anh nhom",
      "đổi avatar nhóm",
      // ——— 0105: thêm cho đủ 40 ———
      "đổi tên nhóm thành lớp 4A",
      "doi ten nhom thanh lop 4a",
      "sửa lại tên nhóm cho đúng",
      "sua lai ten nhom cho dung",
      "tên nhóm gõ sai, cho sửa lại",
      "ten nhom go sai cho sua lai",
      "cập nhật ảnh đại diện của nhóm",
      "cap nhat anh dai dien cua nhom",
      "thay hình nhóm",
      "thay hinh nhom",
      "đặt lại tên cho nhóm quỹ",
      "dat lai ten cho nhom quy",
      "muốn đổi tên nhóm thì làm thế nào?",
      "muon doi ten nhom thi lam the nao",
      "sửa mô tả nhóm",
      "sua mo ta nhom",
      "viết lại giới thiệu nhóm",
      "viet lai gioi thieu nhom",
      "đổi tên nhóm hội đồng hương",
      "doi ten nhom hoi dong huong",
      "up ảnh bìa mới cho nhóm",
      "up anh bia moi cho nhom",
      "chỉnh thông tin nhóm",
      "chinh thong tin nhom",
      "tải ảnh nhóm lên",
      "tai anh nhom len",
      "xoá ảnh đại diện nhóm",
      "xoa anh dai dien nhom",
      "sửa tên đội bóng công ty",
      "sua ten doi bong cong ty",
      "đổi tên và ảnh nhóm luôn",
      "doi ten va anh nhom luon",
      "nhóm đổi tên được không",
      "nhom doi ten duoc khong",
      "sửa tên nhóm",
    ],
  },
  screen: "/groups/:groupId/settings",
  screenShows: "group_info_edit",
  endpoints: [
    "PATCH /groups/{groupId}",
    "PUT /groups/{groupId}/avatar",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở cài đặt nhóm để bạn sửa tên và ảnh nhé.",
  },
  journey: { after: ["GRP-OPEN"] },
  help: { title: "Sửa tên / ảnh nhóm", tryNow: "đổi tên nhóm" },
} satisfies AiCapabilityPage;
